var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 273,
    height: 179,
    viewBox: "0 0 273 179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6595",
    "data-name": "Rect\\xE1ngulo 6595",
    width: 18.514,
    height: 18.554,
    fill: "#e6e6e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty_state_img",
    "data-name": "empty state img",
    transform: "translate(-8.973 -255.69)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6626",
    "data-name": "Rect\\xE1ngulo 6626",
    width: 273,
    height: 179,
    transform: "translate(8.973 255.69)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6616",
    "data-name": "Rect\\xE1ngulo 6616",
    width: 66.385,
    height: 7.295,
    rx: 3.648,
    transform: "translate(81.867 323.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6623",
    "data-name": "Rect\\xE1ngulo 6623",
    width: 13.861,
    height: 7.295,
    rx: 3.648,
    transform: "translate(200.048 323.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6622",
    "data-name": "Rect\\xE1ngulo 6622",
    width: 123.287,
    height: 13.131,
    rx: 6.566,
    transform: "translate(72.383 398.937)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_8",
    "data-name": "Sustracci\\xF3n 8",
    d: "M157.217,53.984H15.95a8.382,8.382,0,0,1,0-16.763H25.9a8.879,8.879,0,1,0,0-17.758H8.129A9.8,9.8,0,0,1,9.8,0H148.228A9.8,9.8,0,0,1,149.9,19.463h-10.02a8.879,8.879,0,1,0,0,17.758h17.337a8.382,8.382,0,0,1,0,16.763Z",
    transform: "translate(56.334 337.658)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8532",
    "data-name": "Grupo 8532",
    transform: "translate(101.792 311.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15316",
    "data-name": "Grupo 15316",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15397",
    "data-name": "Grupo 15397",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9353",
    "data-name": "Trazado 9353",
    transform: "translate(0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.16728973388672 106.7132186889648 L 11.54064750671387 106.7132186889648 C 5.728518962860107 106.7132186889648 1.000004768371582 101.9846801757812 1.000004768371582 96.17250823974609 L 1.000004768371582 11.54070568084717 C 1.000004768371582 5.728548526763916 5.728518962860107 1.000005483627319 11.54064750671387 1.000005483627319 L 66.62647247314453 1.000005483627319 C 66.72005462646484 1.038698554039001 67.01664733886719 1.195733308792114 67.72257995605469 1.813405513763428 C 68.3212890625 2.337276935577393 69.04320526123047 3.039934158325195 69.80750274658203 3.783834218978882 C 70.742919921875 4.694291114807129 71.80314636230469 5.726219654083252 72.85646057128906 6.641605377197266 C 73.81730651855469 7.471405506134033 75.96510314941406 9.669590950012207 77.90026092529297 11.91533374786377 C 80.92172241210938 15.42175674438477 81.55704498291016 16.81774711608887 81.68965911865234 17.25632476806641 L 81.70791625976562 96.17273712158203 C 81.70791625976562 101.9846801757812 76.97941589355469 106.7132186889648 71.16728973388672 106.7132186889648 Z M 82.68183135986328 17.89766311645508 C 82.16168212890625 17.89766311645508 81.79695129394531 17.52096939086914 81.70746612548828 17.12908172607422 L 83.66989135742188 17.05105018615723 C 83.64887237548828 17.1875 83.58454132080078 17.40826034545898 83.39027404785156 17.60334777832031 L 82.68183135986328 17.89766311645508 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.54064178466797 2.000007629394531 C 6.279914855957031 2.000007629394531 1.999992370605469 6.279945373535156 1.999992370605469 11.54069519042969 L 1.999992370605469 96.17251586914062 C 1.999992370605469 101.4332656860352 6.279914855957031 105.7132034301758 11.54064178466797 105.7132034301758 L 71.16728210449219 105.7132034301758 C 76.42800903320312 105.7132034301758 80.70791625976562 101.4332656860352 80.70791625976562 96.1729736328125 L 80.68970489501953 17.42243194580078 C 80.46343231201172 16.86355590820312 79.51345062255859 15.31487274169922 77.10649871826172 12.52613067626953 C 75.21208190917969 10.33122253417969 73.12679290771484 8.196372985839844 72.20520782470703 7.400466918945312 L 72.20051574707031 7.396408081054688 C 71.12590026855469 6.462516784667969 70.054931640625 5.420112609863281 69.11002349853516 4.500434875488281 C 68.17838287353516 3.593650817871094 66.93264770507812 2.381156921386719 66.3641357421875 2.000007629394531 L 11.54064178466797 2.000007629394531 M 11.54064178466797 7.62939453125e-06 L 66.69302368164062 7.62939453125e-06 C 67.71772766113281 7.62939453125e-06 70.60763549804688 3.362403869628906 73.51242065429688 5.886802673339844 C 75.5211181640625 7.621543884277344 82.16568756103516 14.73974609375 82.68963623046875 17.12979125976562 C 82.66762542724609 16.85356903076172 82.68963623046875 16.7886962890625 82.68963623046875 17.12979125976562 L 82.70791625976562 96.17251586914062 C 82.70791625976562 102.5462951660156 77.54099273681641 107.7132034301758 71.16728210449219 107.7132034301758 L 11.54064178466797 107.7132034301758 C 5.166915893554688 107.7132034301758 -7.62939453125e-06 102.5462951660156 -7.62939453125e-06 96.17251586914062 L -7.62939453125e-06 11.54069519042969 C -7.62939453125e-06 5.166946411132812 5.166915893554688 7.62939453125e-06 11.54064178466797 7.62939453125e-06 Z",
    stroke: "none",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "isologo",
    d: "M12.889,28.3H7.942a8.961,8.961,0,0,1-1.218-.124,11.06,11.06,0,0,1-1.252-.279,9.675,9.675,0,0,1-1.44-.535A7,7,0,0,1,1.31,25.191a6.41,6.41,0,0,1-.922-1.8A8.22,8.22,0,0,1,0,21.008a9.25,9.25,0,0,1,.314-2.444,7.816,7.816,0,0,1,.828-1.948A8.411,8.411,0,0,1,3.656,14,10.57,10.57,0,0,1,5,13.221a11.387,11.387,0,0,1,1.171-.489A8.623,8.623,0,0,1,7.313,12.4h0a4.493,4.493,0,0,1-.039-.594,6.314,6.314,0,0,1,.16-1.456,5.44,5.44,0,0,1,2.59-3.529,5.94,5.94,0,0,1,2.867-.811V28.3Zm13.443,0H18.119V23.844l2.514-2.405,5.7,6.858Zm10.214,0H32.668L24.488,18.221,32,10.811H25.762l-7.643,7.02V4.268A11.061,11.061,0,0,1,21.38,1.382a10.234,10.234,0,0,1,2.415-1A11.5,11.5,0,0,1,26.8,0c.441,0,.9.023,1.355.068a13.576,13.576,0,0,1,1.839.348,11.27,11.27,0,0,1,1.591.548,9.6,9.6,0,0,1,2.509,1.573,10.247,10.247,0,0,1,2.825,4.2,13.835,13.835,0,0,1,.6,2.132,15.665,15.665,0,0,1,.253,1.827A12.606,12.606,0,0,1,37.8,12.45h0a8.651,8.651,0,0,1,1.16.348,11.04,11.04,0,0,1,1.18.516,10.129,10.129,0,0,1,1.338.814,8.014,8.014,0,0,1,2.428,2.738,7.674,7.674,0,0,1,.727,2.03,9.487,9.487,0,0,1,.162,2.542,8.6,8.6,0,0,1-.644,2.262,7.133,7.133,0,0,1-1.068,1.7A7.7,7.7,0,0,1,40.3,27.436a9.9,9.9,0,0,1-1.4.5,10.827,10.827,0,0,1-1.2.256,8.321,8.321,0,0,1-1.162.108h0Z",
    transform: "translate(18.943 39.708)",
    fill: "#e6e6e6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8531",
    "data-name": "Grupo 8531",
    transform: "translate(45.125 277.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15201",
    "data-name": "Grupo 15201",
    transform: "translate(0 4.903) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15398",
    "data-name": "Grupo 15398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15399",
    "data-name": "Grupo 15399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6615",
    "data-name": "Rect\\xE1ngulo 6615",
    width: 32.692,
    height: 22.823,
    rx: 11.411,
    transform: "translate(2.781 0) rotate(7)",
    fill: "#e6e6e6",
    opacity: 0.955
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9355",
    "data-name": "Trazado 9355",
    d: "M.652.761a1.1,1.1,0,0,1,2.1,0C5.761,8.821,5.76,8.753,5.609,8.671L2.17,6.481C-.47,4.111-.06,4,.171,3.284Z",
    transform: "matrix(-0.819, 0.574, -0.574, -0.819, 29.496, 27.425)",
    fill: "#e6e6e6",
    opacity: 0.911
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15400",
    "data-name": "Grupo 15400",
    transform: "translate(169.958 277.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15247",
    "data-name": "Grupo 15247",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9449",
    "data-name": "Trazado 9449",
    d: "M21.219,5.657H17.687l.645-4.08A1.28,1.28,0,0,0,17.09,0a1.873,1.873,0,0,0-1.747,1.577L14.7,5.657H9.564l.649-4.08A1.28,1.28,0,0,0,8.966,0,1.855,1.855,0,0,0,7.223,1.577l-.649,4.08H3.042A1.818,1.818,0,0,0,1.31,7.141,1.243,1.243,0,0,0,2.568,8.625H6.1l-.812,5.156H1.755A1.818,1.818,0,0,0,.023,15.265,1.246,1.246,0,0,0,1.28,16.748H4.819l-.634,4.006a1.28,1.28,0,0,0,1.243,1.577,1.877,1.877,0,0,0,1.747-1.577l.612-3.984h5.149l-.631,3.984a1.283,1.283,0,0,0,1.246,1.577,1.873,1.873,0,0,0,1.743-1.577l.631-3.984h3.531a1.821,1.821,0,0,0,1.732-1.484A1.243,1.243,0,0,0,19.932,13.8H16.4l.812-5.134h3.531a1.818,1.818,0,0,0,1.732-1.484,1.243,1.243,0,0,0-1.258-1.528ZM13.41,13.781H8.277l.812-5.134h5.134Z",
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8536",
    "data-name": "Grupo 8536",
    transform: "translate(115.06 267.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15118",
    "data-name": "Grupo 15118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15114",
    "data-name": "Grupo 15114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6613",
    "data-name": "Rect\\xE1ngulo 6613",
    width: 29.543,
    height: 20.242,
    rx: 9,
    transform: "translate(0)",
    fill: "#e6e6e6",
    opacity: 0.912
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9354",
    "data-name": "Trazado 9354",
    d: "M5.744,0A5.744,5.744,0,1,1,0,5.744,5.744,5.744,0,0,1,5.744,0Z",
    transform: "translate(9.3 4.377)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_442",
    "data-name": "Elipse 442",
    transform: "translate(10.394 5.471)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.65,
    cy: 4.65,
    rx: 4.65,
    ry: 4.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.65,
    cy: 4.65,
    rx: 3.15,
    ry: 3.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9352",
    "data-name": "Trazado 9352",
    d: "M0,.909A3.467,3.467,0,0,1,1.591,0",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 23.613, 2.762)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8534",
    "data-name": "Grupo 8534",
    transform: "translate(26.424 355.524)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1393",
    "data-name": "L\\xEDnea 1393",
    y2: 2.017,
    transform: "translate(0 8.916)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1394",
    "data-name": "L\\xEDnea 1394",
    y2: 6.341,
    transform: "translate(2.882 6.792)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1395",
    "data-name": "L\\xEDnea 1395",
    y2: 16.857,
    transform: "translate(5.764 1.442)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1396",
    "data-name": "L\\xEDnea 1396",
    y2: 19.577,
    transform: "translate(11.476)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1397",
    "data-name": "L\\xEDnea 1397",
    y2: 15.404,
    transform: "translate(14.606 2.087)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1398",
    "data-name": "L\\xEDnea 1398",
    y2: 2.017,
    transform: "translate(17.292 8.916)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1399",
    "data-name": "L\\xEDnea 1399",
    y2: 6.341,
    transform: "translate(20.175 6.792)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1400",
    "data-name": "L\\xEDnea 1400",
    y2: 16.857,
    transform: "translate(23.057 1.442)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1401",
    "data-name": "L\\xEDnea 1401",
    y2: 13.399,
    transform: "translate(25.744 3.09)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1402",
    "data-name": "L\\xEDnea 1402",
    y2: 6.341,
    transform: "translate(8.594 5.675)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8535",
    "data-name": "Grupo 8535",
    transform: "translate(215.987 294.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_8",
    "data-name": "Pol\\xEDgono 8",
    d: "M5.8,8.514a4,4,0,0,1,7.346,0l3.394,7.868a4,4,0,0,1-3.673,5.584H6.082a4,4,0,0,1-3.673-5.584Z",
    transform: "matrix(0, 1, -1, 0, 21.967, 0)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8537",
    "data-name": "Grupo 8537",
    transform: "translate(221.933 349.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15120",
    "data-name": "Grupo 15120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15109",
    "data-name": "Grupo 15109",
    transform: "translate(0 0)",
    opacity: 0.908
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15104",
    "data-name": "Grupo 15104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9349",
    "data-name": "Trazado 9349",
    d: "M15.746,11.842a2.143,2.143,0,0,0-3.031,0l-1.137,1.137a1.653,1.653,0,0,1-2.273,0A17.834,17.834,0,0,1,4.986,8.66a1.683,1.683,0,0,1,0-2.273L6.123,5.25a2.143,2.143,0,0,0,0-3.031L4.532.628A2.143,2.143,0,0,0,1.5.628L1.256.873A4.286,4.286,0,0,0,.328,5.549l.408.982a19.824,19.824,0,0,0,10.7,10.7l.982.408a4.286,4.286,0,0,0,4.676-.927l.245-.245a2.143,2.143,0,0,0,0-3.031ZM9.356,4.489a6.1,6.1,0,0,1,4.059,3.974.481.481,0,0,0,.51.327l.027,0a.482.482,0,0,0,.408-.62A6.822,6.822,0,0,0,9.636,3.542a.483.483,0,0,0-.613.411l0,.023a.481.481,0,0,0,.335.513m.269-2.078A7.578,7.578,0,0,1,15.5,8.186a.483.483,0,0,0,.523.371h.011a.482.482,0,0,0,.419-.581q-.084-.388-.2-.765a8.228,8.228,0,0,0-5.52-5.52,9.288,9.288,0,0,0-.908-.23.482.482,0,0,0-.574.42v.009a.481.481,0,0,0,.373.523",
    transform: "translate(0 0.589)",
    fill: "#e6e6e6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIco);
export default __webpack_public_path__ + "static/media/video_ico.b49686d97aaa9e7d3fb571ec3c232fc5.svg";
export { ForwardRef as ReactComponent };